import { ServiceCompanies } from '@/service/companies/serviceCompanies'

const apigrupo = new ServiceCompanies()
export default {
  namespaced: true,
  state: {
    groups: [],
    groupDetails: {},
    loading: false, // Estado de loading
  },
  mutations: {
    SET_LOADING(state, status) {
      state.loading = status
    },
    SET_GROUPS(state, groups) {
      state.groups = groups
    },
    SET_GROUP_DETAILS(state, groupDetails) {
      state.groupDetails = groupDetails
    },
  },
  actions: {
    async fetchGroups({ commit }, query) {
      commit('SET_LOADING', true) // Inicia o loading
      try {
        const response = await apigrupo.getListCompaniesAdmin(query)
        commit('SET_GROUPS', response.empresas)
      } catch (error) {
        console.error('Erro ao buscar grupos:', error)
      } finally {
        commit('SET_LOADING', false) // Finaliza o loading
      }
    },

    async fetchGroupDetails({ commit }, id) {
      commit('SET_LOADING', true) // Inicia o loading
      try {
        const response = await apigrupo.getCompaniesDetails(id)
        commit('SET_GROUP_DETAILS', response)
      } catch (error) {
        console.error('Erro ao buscar detalhes do grupo:', error)
      } finally {
        commit('SET_LOADING', false) // Finaliza o loading
      }
    },

    async generePagarme({ commit }, id) {
      commit('SET_LOADING', true) // Inicia o loading
      try {
        await apigrupo.generePagarme(id)
        const response = await apigrupo.getCompaniesDetails(id)
        commit('SET_GROUP_DETAILS', response)
      } catch (error) {
        console.error('Erro ao gerar pagarme:', error)
      } finally {
        commit('SET_LOADING', false) // Finaliza o loading
      }
    },
    // recebe o id da empresa e o status para atualizar
    async statusCompany({ commit }, { id, status }) {
      commit('SET_LOADING', true) // Inicia o loading
      try {
        await apigrupo.statusCompany(id, status)
        const response = await apigrupo.getCompaniesDetails(id)
        commit('SET_GROUP_DETAILS', response)
      } catch (error) {
        console.error('Erro ao aprovar empresa:', error)
      } finally {
        commit('SET_LOADING', false) // Finaliza o loading
      }
    },

    async uploadCnpj({ commit }, { id, data }) {
      commit('SET_LOADING', true) // Inicia o loading
      try {
        await apigrupo.uploadCnpj(id, data)
        const response = await apigrupo.getCompaniesDetails(id)
        commit('SET_GROUP_DETAILS', response)
      } catch (error) {
        console.error('Erro ao gerar pagarme:', error)
      } finally {
        commit('SET_LOADING', false) // Finaliza o loading
      }
    },

    async deleteCnpjDocument({ commit }, id) {
      commit('SET_LOADING', true) // Inicia o loading
      try {
        await apigrupo.deleteCnpjDocument(id)
        const response = await apigrupo.getCompaniesDetails(id)
        commit('SET_GROUP_DETAILS', response)
      } catch (error) {
        console.error('Erro ao gerar pagarme:', error)
      } finally {
        commit('SET_LOADING', false) // Finaliza o loading
      }
    },
  },
}
